module.exports = __webpack_public_path__ + "static/media/estro-controll.d306f35c.jpg";